import React, { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import useDashboardActiveTab from 'src/dashboard/helpers/active-tab.hook';

import { DashboardSettingsContent } from 'src/dashboard/settings/content';
import { DashboardSettingsTabs } from 'src/dashboard/settings/tabs';
// import JoyRideOnboardingGuide from 'src/onboarding/joyride-onboarding'

export type SettingsTabTypes =
  | 'organization'
  | 'members'
  | 'branding'
  | 'theme'
  | 'billing'
  | 'integrations'
  | 'workspaces'
  | 'account'
  | 'behavior'
  | 'apikey';

export interface PageSettingsProps {
  activeTab: SettingsTabTypes;
}

export const PageSettings = ({ activeTab }: PageSettingsProps) => {

  const [domLoaded, setDomLoaded] = useState(false);

  useEffect(()=>{
    const handler = setTimeout(() => {
      setDomLoaded(true);
    }, 2000);

    return () => {
      clearTimeout(handler);
    };
  },[])

  useDashboardActiveTab('settings');

  const pageTitle = useMemo(
    () => `Journey | ${activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} Settings`,
    [activeTab]
  );

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <div className='flex flex-col mt-md space-y-6'>
        <h1 className='text-bedrock-h1 font-brand-serif text-bedrock-black'>Settings</h1>
        {/* { domLoaded && <JoyRideOnboardingGuide initial={false} /> } */}

        <div>
          <div className='mb-6'>
            <DashboardSettingsTabs activeTab={activeTab} />
          </div>
          <DashboardSettingsContent activeTab={activeTab} />
        </div>
      </div>
    </>
  );
};
